import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Typography,
  FormControlLabel,
  RadioGroup,
  FormControl,
} from "@material-ui/core";
import moment from "moment";
import { translate as t } from "../../../../translate/localization";
import renderApproveRentingModal from "../../render-approve-renting-modal";
import useStyles, { CustomRadio } from "../../styles";

export default function RowWhoPaysQuotas({ defaultValues, callback, ...rest }) {
  const { secondColumn } = useStyles();

  return (
    <>
      <Grid item xs={6} container alignItems="center">
        <Typography variant="body2">
          {t("request-section.who-pays-the-quotas")}:
        </Typography>
      </Grid>
      <Grid item xs={6} className={secondColumn}>
        <FormControl component="fieldset">
          <RadioGroup
            name="who-pays-the-quotas"
            value={defaultValues.whoPaysQuotas}
            onChange={(e) => {
              const whoPayValue = e.target.value;
              renderApproveRentingModal({
                defaultValues: {
                  ...rest,
                  whoPaysQuotas: whoPayValue,
                  whoPaysVat: whoPayValue === "both" ? "employee" : whoPayValue,
                },
                callback,
              });
            }}
          >
            <Grid item container xs={12} alignItems="center">
              <FormControlLabel
                value="employee"
                control={<CustomRadio disableRipple />}
                label={
                  <Typography variant="body2">
                    {t("request-section.the-employee")}
                  </Typography>
                }
              />
              <FormControlLabel
                value="company"
                control={<CustomRadio disableRipple />}
                label={
                  <Typography variant="body2">
                    {t("request-section.the-company")}
                  </Typography>
                }
              />
              <FormControlLabel
                value="both"
                control={<CustomRadio disableRipple />}
                label={
                  <Typography variant="body2">
                    {t("request-section.both-of-them")}
                  </Typography>
                }
              />
            </Grid>
          </RadioGroup>
        </FormControl>
      </Grid>
    </>
  );
}

RowWhoPaysQuotas.defaultProps = {
  defaultValues: {
    privateUsePercentage: 0,
    energeticEfficiency: 0,
    purchasePrice: 0,
    initialAmount: 0,
    rentingQuota: 0,
    rentingCompanyQuota: 0,
    rentingEmployeeQuota: 0,
    date: new Date(moment().add(1, "months").startOf("month")),
    numberOfQuotas: 0,
    whoPaysQuotas: "employee",
    whoPaysVat: "employee",
  },
  callback: () => {},
};

RowWhoPaysQuotas.propTypes = {
  defaultValues: PropTypes.object,
  callback: PropTypes.func,
};
